module.exports = __webpack_public_path__ + "static/Janowo_Park_III_ujecie_01-b0b4880a2b320225d91c443062029e82.jpg";